//TODO: GROW-2166 when Productizing if fixed win update the InverseHeader in core component and fix imports
import { usePathname } from 'next/navigation';

import { EventType } from '@/analytics/types';
import InverseHeader from '@/app/components/Experiments/FixedHeader/InverseHeader/InverseHeader';
import LandingPageHero from '@/app/components/LandingPage/LandingPageHero';

const GiftHero = (): JSX.Element => {
  const path = usePathname();

  const handleCtaClick = () => {
    void window.ouraAnalytics.track(EventType.CTAClicked, {
      cta: 'shop_now',
      action: 'go_to_pdp',
      location: 'hero_module',
      module: 'hero_module',
      path,
    });
  };

  return (
    <InverseHeader enter>
      <LandingPageHero
        backgroundImage={{
          alt: '',
          srcSet: [
            {
              media: '(max-width: 1023px)',
              src: 'holiday23/gifting-hero-mobile.jpg?bri=-10',
            },
            {
              media: '(min-width: 1024px)',
              src: 'holiday23/gifting-hero-desktop.jpg?bri=-10',
            },
          ],
        }}
        backgroundProps={{
          color: 'sandstone-200',
          gradients: [],
        }}
        copy="holiday_delight_everyone_on_your_list"
        cta={{
          href: '/product/rings',
          label: 'call_to_action_button_text',
          onClick: handleCtaClick,
        }}
        data-cy="gift-hero"
        title="holiday_smartest_gift_ever"
        titleProps={{
          indentation: 'pl-[10rem] md:pl-[15rem] lg:pl-[20rem]',
          typographyProps: {
            className: 'en:lg:whitespace-nowrap',
          },
        }}
        textColor="text-sandstone-200"
      />
    </InverseHeader>
  );
};

export default GiftHero;
